import React, { FunctionComponent } from 'react';
import TicketDonationField, {
    TicketDonationCardField,
    TicketDonationFieldProps,
} from '../../../components/ticketsSelectionList/TicketDonationField';
import { TicketsFormat } from '../../../constants/statsig';

export interface TicketDonationSwitcherProps extends TicketDonationFieldProps {
    ticketsFormat: TicketsFormat;
}

export const TicketDonationSwitcher: FunctionComponent<
    TicketDonationSwitcherProps
> = ({
    id,
    isDisabled,
    onChange,
    amount,
    currencySymbol,
    currencyFormat,
    isCurrencySuffix,
    ticketsFormat,
}) => {
    const props = {
        id,
        isDisabled,
        onChange,
        amount,
        currencySymbol,
        currencyFormat,
        isCurrencySuffix,
    };
    const donationField =
        ticketsFormat === TicketsFormat.card ? (
            <TicketDonationCardField {...props} />
        ) : (
            <TicketDonationField {...props} />
        );
    return (
        <div className="eds-ticket-card-content__donation-field">
            {donationField}
        </div>
    );
};

export default TicketDonationSwitcher;
